import type { FC } from 'react'

import { getCurrency } from '@common/utils/currency.ts'

import InfoIcon from '@/assets/icons/icon-info.svg'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import type { CategoryChartType } from '@/modules/overview/types.ts'
import { SalesEditableInput } from '@/modules/sales-editor/components/input'
import { convertHexToRGBA } from '@/utils/helpers'

interface Props {
  data: CategoryChartType
  showCents?: boolean
}

export const CategoryBox: FC<Props> = ({
  data: { title, tooltip, value, color, icon, onChange, testId },
  showCents,
}) => {
  const transparentColor = convertHexToRGBA(color, 0.1)

  return (
    <div
      key={title}
      className="flex items-center justify-between overflow-hidden rounded-md border-l-4 bg-opacity-5 px-6 py-2"
      style={{
        backgroundColor: transparentColor,
        borderColor: color,
      }}
      data-testid={testId}
    >
      <div className="flex min-w-[100px] flex-col">
        <span className="text-secondary-500 font-medium dark:text-white">
          <SalesEditableInput
            value={value}
            onChange={(value) => onChange(Number(value))}
            format={(value) => getCurrency(value, showCents ? 2 : 0)}
          />
        </span>
        <span
          className="flex flex-row gap-1 text-secondary-400 dark:text-secondary-300 text-sm font-medium"
          data-testid={`${testId}-title`}
        >
          {title}
          <Tooltip content={tooltip}>
            <InfoIcon />
          </Tooltip>
        </span>
      </div>
      <div
        className="invisible rounded-lg p-2 sm:visible"
        style={{ backgroundColor: transparentColor }}
      >
        {icon}
      </div>
    </div>
  )
}
